import React from "react";
import Modal from "../Modal";
import Button from "../Button";
import { useLocalization } from "../../../context/LocalizeContextProvider";

/**
 * Confirmation modal shown when the user tries to switch away from a form
 * that has unsaved changes (intra-page tab switch on the assessment page).
 *
 * Router-level navigation (browser back, in-app links, etc.) is guarded by
 * <Prompt> in the parent — this modal is only used for cases <Prompt> can't
 * intercept.
 */
export default function UnsavedChangesModal({
  visible,
  onCancel,
  onLeave,
}) {
  const localize = useLocalization();

  return (
    <Modal
      visible={visible}
      handleHideModal={onCancel}
      centered
      size="sm"
      title={localize.getText("unsavedChangesTitle")}
    >
      <div className="d-flex flex-column gap-3">
        <p className="mb-0">{localize.getText("unsavedChangesBody")}</p>
        <div className="d-flex justify-content-end gap-2">
          <Button
            label={localize.getText("cancel")}
            variant="outline-primary"
            onClick={onCancel}
          />
          <Button
            label={localize.getText("unsavedChangesLeave")}
            variant="danger"
            onClick={onLeave}
          />
        </div>
      </div>
    </Modal>
  );
}
